import React from "react";
import ReactMarkdown from "react-markdown";
import "./Contact.css";
import contact from "../../markdown/Contact.md";

const Contact = () => (
  <div className="about">
    <ReactMarkdown source={contact} className="text" />
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact/Contact.js